import { render, staticRenderFns } from "./PlandayPortals.vue?vue&type=template&id=d6dc2b8e&"
import script from "./PlandayPortals.vue?vue&type=script&lang=js&"
export * from "./PlandayPortals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports